import {
  useQueries,
  type QueryFunctionContext,
  type UseQueryResult,
} from '@tanstack/react-query';
import { dataApiClient } from '../../infrastructure/dataApi/client';
import { useCurrentSimDataId } from '../SimViewer/useCurrentSimDataId';
import { useApiDataFilter } from '../SimViewer/useApiDataFilter';
import { useSchemaComparison } from '../SimViewer/useSchemaComparison';

type UseSummaryComparisonsData = {
  isLoading: boolean;
  summariesMap: Record<string, number | undefined>;
};

const useSummaryComparisonsData = (): UseSummaryComparisonsData => {
  const { currentSimDataId } = useCurrentSimDataId();
  const { comparisons } = useSchemaComparison();
  const { apiFilter } = useApiDataFilter();

  const simDataIds = currentSimDataId ? [currentSimDataId, ...comparisons] : [];

  const results = useQueries({
    queries: simDataIds.map((simDataId: string) => {
      return {
        queryKey: ['summary', simDataId, apiFilter],
        queryFn: async ({ signal }: QueryFunctionContext): Promise<number> => {
          return dataApiClient.getSummary(simDataId, apiFilter, signal);
        },
        meta: { dataType: 'others' },
      };
    }),
  });

  return {
    isLoading: results.some((result: UseQueryResult): boolean => {
      return result.isFetching;
    }),
    summariesMap: Object.fromEntries(
      simDataIds.map(
        (simDataId: string, index: number): [string, number | undefined] => {
          return [simDataId, results[index].data];
        }
      )
    ),
  };
};

export { useSummaryComparisonsData };
